import { render } from "./ImprintTabs.vue?vue&type=template&id=0154de88"
import script from "./ImprintTabs.vue?vue&type=script&lang=js"
export * from "./ImprintTabs.vue?vue&type=script&lang=js"

import "./ImprintTabs.vue?vue&type=style&index=0&id=0154de88&lang=css"

import exportComponent from "/buddy/vue-imprint-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__